import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Authenticated from '@/Layouts/Authenticated';
import EPaperCard from '@/Components/EPaperCard';

export default function EPaper({ app, auth, instructions }) {
    const [pubs, setPubs] = useState([])

    useEffect(async () => {
        const res = await axios.get(route('epaper.publications'))
        setPubs(res.data)
    }, [])

    return (
        <Authenticated app={app} auth={auth}>
            <div className="category-title">
                <div className="container">
                    <h1>美國星島日報電子版</h1>
                </div>
            </div>

            <div className="content-wrapper">
                <div className="container">
                    <h1 className="text-center mx-5">
                        {instructions.map((item, index) => (
                            <a key={index} href={item.link}>
                                <img src={item.thumbnail} />
                            </a>
                        ))}
                    </h1>

                    {pubs && (
                        <section className="section-cards">
                            <div className="row gy-5">
                                {pubs.map(pub => (
                                    <EPaperCard key={pub.code} name={pub.name} image={pub.thumbnail} link={pub.link} />
                                ))}
                            </div>
                        </section>
                    )}
                </div>
            </div>
        </Authenticated>
    );
}
